var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBabyGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 770681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.2417 13.3706C29.2417 14.6423 28.5001 16.5 26.6879 16.6474C25.1442 21.4914 20.6079 25 15.2522 25C9.89643 25 5.3601 21.4914 3.81643 16.6474C2.5001 16.5 1.39384 15.5754 0.999991 14C0.5 12 1.57183 10.2836 3.56086 10.2836C4.7918 4.96465 9.55902 1 15.2522 1C20.9453 1 25.7125 4.96465 26.9435 10.2836C29.0001 10.2836 29.2417 12.4364 29.2417 13.3706Z",
    stroke: "#7A9198",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95383 11.8082C9.35642 11.8097 8.87098 11.3266 8.86963 10.7292C8.86814 10.1319 9.35118 9.64664 9.94844 9.64515C10.5415 9.64365 11.025 10.12 11.0326 10.7129C11.0326 11.3115 10.5521 11.7992 9.95383 11.8082Z",
    fill: "#7A9198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6619 10.7226C21.6634 11.319 21.1811 11.804 20.5845 11.8053C19.988 11.807 19.5031 11.3245 19.5016 10.728C19.5001 10.1313 19.9826 9.64664 20.5789 9.64514H20.5818C21.1826 9.65263 21.6649 10.1435 21.6619 10.7445V10.7226Z",
    fill: "#7A9198"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M11.1894 17.578C11.0679 17.2871 11.2938 17 11.609 17H18.459C18.7506 17 18.9724 17.2482 18.8861 17.5268C18.6196 18.3874 17.7481 20 14.9585 20C12.5409 20 11.5535 18.4497 11.1894 17.578Z",
    stroke: "#7A9198",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3129",
    d: "M15.0002 1.5C13.0848 2.47725 11.8731 6.84445 15.116 7.39726C18.359 7.95007 17.9601 4.17142 16.6432 3.80949",
    stroke: "#7A9198",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyGood);
export default __webpack_public_path__ + "static/media/baby-good.0fb06105b4537444e1ffae30c9169c18.svg";
export { ForwardRef as ReactComponent };